import {ApiProvider, IBaseComponent} from "@renta-apps/athenaeum-react-common";
import DepotModel from "../models/server/DepotModel";

export const getDepots = async (): Promise<DepotModel[]> => {
    return await ApiProvider.getAsync(`/api/Locations/GetInternalAndPublicDepots`, null);
};

export const getRentalOffices = async (): Promise<DepotModel[]>  => {
    return await ApiProvider.postAsync(`/api/Locations/GetAll`, null, null);
}